import {
  CreateDashboardMutationVariables,
  DashboardDeviceType,
  UpdateDashboardMutationVariables,
} from '@akin-home/amplify';
import { DashboardTemplate } from '@akin-home/dashboards';
import { listAllTabletDashboardsForUser } from '@akin-home/dashboards/frontend';

type Props = {
  user_id: string;
  dashboard_template: DashboardTemplate;

  update(data: UpdateDashboardMutationVariables): Promise<any>;
  create(data: CreateDashboardMutationVariables): Promise<any>;
};

export async function saveUserDashboardFromTemplate(props: Props) {
  const { user_id, dashboard_template } = props;

  const existing_dashboard = (await listAllTabletDashboardsForUser(user_id))[0];

  if (existing_dashboard) {
    await props.update({
      input: {
        id: existing_dashboard.id,
        layout: JSON.stringify(dashboard_template.layout),
      },
    });
  } else {
    await props.create({
      input: {
        user_id,
        device_type: DashboardDeviceType.tablet,
        name: 'User Dashboard: ' + user_id,
        layout: JSON.stringify(dashboard_template.layout),
      },
    });
  }
}
